import { Component, OnInit } from '@angular/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { IncidentTabsDto } from '@cradua/data';

@Component({
  selector: 'cradua-incidenttabs-container',
  templateUrl: './incidenttabs-container.component.html',
  styleUrls: ['./incidenttabs-container.component.scss']
})
export class IncidenttabsContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentTabss$: Observable<IncidentTabsDto[]>;
  loading: boolean;
  isLoadingIncidentTabs$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}


  ngOnInit() {
   
    this.isLoadingIncidentTabs$ = this.gatwayFacade.isLoadingGateway("IncidentTabs");
    this.incidentTabss$ = this.gatwayFacade.loadGateway("IncidentTabs");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

 onDeleteIncidentTabs(deletedValue: any) {
    this.gatwayFacade.remove("IncidentTabs", deletedValue);
  }


// this method control both the create and update

onSubmitIncidentTabs(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.IncidentTabss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllIncidentTabs = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIncidentTabs.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllIncidentTabs.length > 0) {
    this.gatwayFacade.add('IncidentTabs', addAllIncidentTabs);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('IncidentTabs', allUpdates, ['id']);
  }

   }

}




